/**
 * Formats a KPI count that was derived from a paginated window, appending "+"
 * only while the server still has pages the tile has not counted.
 *
 * The `n > 0` guard is the load-bearing part: a zero count is complete no
 * matter how many pages follow, so "0+" would claim "there is more" while the
 * list underneath says "nothing yet" — the summary-contradicts-its-own-list
 * defect. Zero always renders as "0".
 */
export function formatCountWithMore(n: number, hasMore: boolean): string {
  return `${n}${hasMore && n > 0 ? "+" : ""}`;
}
